var MAX = 2147483648;

module.exports = function generateId() {
  return Math.floor(Math.random() * MAX).toString(36) + Math.abs(Math.floor(Math.random() * MAX) ^ Date.now()).toString(36) // eslint-disable-line no-bitwise
  ;
};